export enum ThemeType {
	ACTION = 'ACTION',
	ANIMALS = 'ANIMALS',
	ANIMATOR = 'ANIMATOR',
	CREATIVE = 'CREATIVE',
	DIGITAL = 'DIGITAL',
	GAMES = 'GAMES',
	LANGUAGE = 'LANGUAGE',
	MUSIC = 'MUSIC',
	OTHER_INTERESTS = 'OTHER_INTERESTS',
	REST = 'REST',
	SCIENCE = 'SCIENCE',
	SPORT = 'SPORT',
}

export const THEMES = [
	ThemeType.ACTION,
	ThemeType.ANIMALS,
	ThemeType.ANIMATOR,
	ThemeType.CREATIVE,
	ThemeType.DIGITAL,
	ThemeType.GAMES,
	ThemeType.LANGUAGE,
	ThemeType.MUSIC,
	ThemeType.OTHER_INTERESTS,
	ThemeType.REST,
	ThemeType.SCIENCE,
	ThemeType.SPORT,
];
